export const PRODUCTION_API_URL = process.env.REACT_APP_PRODUCTION_API_URL;
export const DEMO_API_URL = process.env.REACT_APP_DEMO_API_URL;
export const STAGING_API_URL = process.env.REACT_APP_STAGING_API_URL;
export const DEV_API_URL = process.env.REACT_APP_DEV_API_URL;
export const QA_API_URL = process.env.REACT_APP_QA_API_URL;